/* this file is for
gastro + sightseeing + events + hotels overview + detail
 */

import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]', function (element) {
    new Tab(element)
});

import {translate} from '@elements/translations';
function accessibleSliderArrowRenderFunction(container, direction, disabled, options) {
    let markupElement = document.createElement('div'),
        arrowMarkup = `<button type="button" class="scroll-slider__arrow scroll-slider__arrow--${direction}" ${disabled ? 'disabled' : ''} aria-label="${translate('scroll-slider-'+ direction + '')}" title="${translate('scroll-slider-'+ direction + '')}"><span class="scroll-slider__arrow-icon ${options.arrowIconClass}" aria-hidden="true"></span></button>`;

    markupElement.innerHTML = arrowMarkup;
    let newArrow = markupElement.childNodes[0];
    container.appendChild(newArrow);

    return newArrow;
}


import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-slide-right",
    arrowRenderFunction: accessibleSliderArrowRenderFunction
});



import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as ajaxFormMap from './scripts/ajax-form-map';
ajaxFormMap.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnReset: true
});

import * as googleMap from './scripts/google-map';
googleMap.init();

import * as anchorNav from '@elements/anchor-nav/bootstrap-5';
anchorNav.init(
    {
        renderItem: function (text, anchor) {
            return '<li class="nav-item anchor-nav__list-item list-inline-item js-anchor-nav__item"><a class="js-anchor-nav__link nav-link anchor-nav__link js-smoothscroll__link" data-scroll-offset="100" href="#' + anchor + '"><span class="anchor-nav__title">' + text + '</span></a></li>';
        },
        smoothScroll: true,
        scrollSpy: false,
        scrollSpyMethod: 'position',
        scrollSpyTarget: '.js-anchor-nav',
        scrollSpyOffset: 300
    },
    {
        list: '.js-anchor-nav__list',
        item: '.js-anchor-nav__item'
    }
);

import {find} from "@elements/dom-utils";
import ScrollSpy from './libs/bootstrap/scrollspy';
new ScrollSpy(document.body, {
    target: find('.js-anchor-nav'),
    offset: 100,
    method: 'position'
});


import * as anchorNavExtension from './scripts/anchor-nav-extension';
anchorNavExtension.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({scrollOffset: 300});

import * as datepicker from '@elements/datepicker';
datepicker.init();

import * as rangeDatepicker from '@elements/datepicker-range';
rangeDatepicker.init();

import * as lazyIframe from '@elements/lazy-iframe';
lazyIframe.init();

import * as setDatepicker from './scripts/set-datepicker';
setDatepicker.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as affix from '@elements/affix';
app.affix = affix.init;

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multiSelectDropdown from './scripts/multiselect-dropdown';
multiSelectDropdown.init();

import * as fetchModal from './scripts/fetch-modal';
fetchModal.init();

import Modal from 'bootstrap/js/dist/modal';
onFind('[data-bs-toggle="modal"]', function (element) {
    new Modal(element);
});

import Tooltip from 'bootstrap/js/dist/tooltip';
onFind('[data-bs-toggle="tooltip"]', function (element) {
    const tooltip = new Tooltip(element);

    element.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            tooltip.hide();
        }
    });
});

import * as iframeSizeBridge from './scripts/iframe';
iframeSizeBridge.init();

